import { dbRefs } from '../services/firebase/init'

export default {
  data () {
    return {
      dbRefs,
      event: {}
    }
  },
  firestore: {
    event: dbRefs.eventRef
  }
}